import axios from  'axios'
const baseURL= "http://targetdemo.asktek.net/bms.inspection.demo.webapi/api/"

//const baseURL= "http://3.109.148.179/padmaapitesting/api/"
 //const baseURL = "http://ISST8-PC:1999/api/"
// const baseURL = "http://localhost:8000/api/"
const instance = axios.create({
    baseURL
   
})


export default  {
  instance ,
  baseURL
}
